import { Component } from "react";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";

import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";

class CefMonitor extends Component {
  componentWillMount() {
    window.updateBalance = amount => {
      this.props.onUpdateBalance(amount);
    };

    window.addToBalance = amount => {
      this.props.addToBalance(amount, true);
    };

    window.helloWorld = () => {
      alert("hello!");
    };

    window.reportMaxPayout = amount => {
      var evt = new CustomEvent("onReportMaxPayout", {
        detail: { amount: amount }
      });
      window.dispatchEvent(evt);
    };

    window.reportDispendedBill = amount => {
      var evt = new CustomEvent("onReportDispendedBill", {
        detail: { amount: amount }
      });
      window.dispatchEvent(evt);
    };

    window.changeServerStatus = code => {
      this.props.onChangeServerStatus(code, true);
    };

    window.showTicket = ticketNumber => {
      alert("show ticket!");
      this.props.setTicketNumberForDetails(ticketNumber);
    };

    window.changePrinterStatuses = printerStatuses => {
      //alert(printerStatuses);
      this.props.onChangePrinterStatuses(printerStatuses, true);
    };

    window.updateBillCounters = billInfo => {
      //alert(billInfo);
      //console.log(billInfo);
      this.props.setTapeBillInfo(JSON.parse(billInfo));
      this.props.changeAdminLoadingIndicator(false);
    };

    window.updateLocalStorage = (key, value) => {
      console.log(
        "--> UPDATED LOCALSTORAGE FROM CEF! KEY: " + key + " VALUE: " + value
      );

      localStorage.setItem(key, value);

      //ako je key za machine info, rokni ga odmah u state
      if (key === LocalStorageKeys.K_LOCAL_STORAGE_KEY_MACHINE_INFO) {
        //odmah ga deserijaliziraj i podesi balance
        var info = JSON.parse(value);

        if (this.props.machineInfo.TerminalLabel === "??") {
          //inicijalizacija, podesi balance
          this.props.onUpdateBalance(info.CurrentBalanceCents);
        }

        this.props.setMachineConfig(value);
      }
    };
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => {
  return {
    activeCalendarItemID: state.rrNavigation.calendarItemID,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onUpdateBalance: amount =>
      dispatch(StoreActions.UpdateBalance(amount, true)),
    onChangeServerStatus: (code, updateStorage) =>
      dispatch(StoreActions.ChangeServerStatus(code, updateStorage)),
    onChangePrinterStatuses: (printerStatuses, updateStorage) =>
      dispatch(
        StoreActions.ChangePrinterStatuses(printerStatuses, updateStorage)
      ),
    setTicketNumberForDetails: ticketNumber =>
      dispatch(StoreActions.SetTicketNumberForDetails(ticketNumber)),
    setTapeBillInfo: billInfo =>
      dispatch(StoreActions.SetTapeBillInfo(billInfo)),
    changeAdminLoadingIndicator: isLoading =>
      dispatch(StoreActions.ChangeAdminLoadingIndicator(isLoading)),
    addToBalance: amount => dispatch(StoreActions.AddToBalance(amount, true)),
    setMachineConfig: config => dispatch(StoreActions.SetMachineInfo(config))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CefMonitor);



// WEBPACK FOOTER //
// ./src/HOCs/CefMonitor/CefMonitor.js